var exports = {
  "r2": "EditGroupModal.module__iconSection___MkJ5az",
  "go": "EditGroupModal.module__iconLabel___MkJ5az",
  "zc": "EditGroupModal.module__iconContainer___MkJ5az",
  "O2": "EditGroupModal.module__iconPreview___MkJ5az",
  "Pz": "EditGroupModal.module__iconPlaceholder___MkJ5az",
  "So": "EditGroupModal.module__iconPlaceholderIcon___MkJ5az",
  "D_": "EditGroupModal.module__iconActions___MkJ5az",
  "Rh": "EditGroupModal.module__iconButtonGroup___MkJ5az",
  "m5": "EditGroupModal.module__iconError___MkJ5az",
};

module.exports = exports;
